import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative h-96 sm:h-[500px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/cd63854374762084f4cf44dd1efda676.webp)`,
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex flex-col lg:flex-row justify-between items-start">
          <div className="text-left mb-8 lg:mb-0">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-navy mb-4 sm:mb-6 leading-tight">
              まずはお気軽に<br />ご相談ください
            </h2>
            <div className="text-left mb-6">
              <p className="text-lg sm:text-xl lg:text-2xl text-navy mb-2 sm:mb-3 leading-relaxed font-semibold">
                図面1枚からでも対応可能です
              </p>
              <p className="text-base sm:text-lg lg:text-xl text-navy/80 leading-relaxed">
                お電話・メールでお問い合わせください
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center bg-navy text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-navy-light transition-all duration-300 shadow-xl hover:shadow-2xl group whitespace-nowrap"
            >
              <span className="mr-3 sm:mr-4">お問い合わせ</span>
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
                <i className="ri-arrow-right-line text-xl sm:text-2xl text-white"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
